import { Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { DocumentNode, FetchPolicy } from '@apollo/client/core'; //InMemoryCache, ApolloClientOptions, ApolloLink,

@Injectable({
  providedIn: 'root'
})
export class ShopifyStorefrontService {

  allProducts: WritableSignal<any[]> = signal([]);

  constructor(
    private apollo: Apollo
  ) { }

  genericQuery(query: DocumentNode, variables: any, fetchPolicy: FetchPolicy = 'cache-first', clientName: string = 'BPUS') {
    return this.apollo.use(clientName).query({
      query,
      variables,
      fetchPolicy,
    });
  }

  genericMutate(mutation: DocumentNode, variables: any, clientName: string = 'BPUS') {
    return this.apollo.use(clientName).mutate({
      mutation,
      variables,
    });
  }

  getCachedProductsByCollectionHandle(handle: string): any[] {
    return this.allProducts().filter((product: any) =>
      product.collections.edges.some((edge: any) => edge.node.handle === handle)
    );
  }

  getCachedProductsByWordInTitle(word: string): any[] {
    return this.allProducts().filter((product: any) => product.title.toLowerCase().includes(word.toLowerCase()));
  }

  getCachedProductByHandle(handle: string): any {
    return this.allProducts().find((product: any) => product.handle === handle);
  }

  getCachedProductsByTag(tag: string): any[] {
    return this.allProducts().filter((product: any) => product.tags.includes(tag));
  }

  getProductByTitle(title: string): any {
    return this.allProducts().find((product: any) => product.title.toLowerCase() === title.toLowerCase());
  }

  getTAAVersionOfProduct(product: any): any {
    const title = product.title;
    const taaTitle = title.replace('BERRY', 'TAA');
    console.log('Looking for:', taaTitle);
    return this.allProducts().find((p: any) => {
      return p.title.toLowerCase() === taaTitle.toLowerCase();
    });
  }

  getBERRYVersionOfProduct(product: any): any {
    const title = product.title;
    const berryTitle = title.replace('TAA', 'BERRY');
    console.log('Looking for:', berryTitle);
    return this.allProducts().find((p: any) => {
      return p.title.toLowerCase() === berryTitle.toLowerCase();
    });
  }

}
